import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { BrandEditorComponent } from "./brand-editor.component";
import { FormsModule } from "@angular/forms";

@Component({
  imports: [CommonModule, FormsModule, BrandEditorComponent],
  standalone: true,
  templateUrl: "./brand-editor-panel.component.html",
  styles: [],
})
export class BrandEditorPanelComponent implements AfterViewInit {
  _branding: string;

  ngAfterViewInit(): void {
    window.addEventListener("message", (event) => {
      switch (event.data.type) {
        case "set-branding":
          console.log(
            "ThemeEditorPanelComponent set branding",
            event.data.branding
          );
          this.branding = event.data.properties;
          break;
      }
    });

    window.parent.postMessage(
      {
        type: "brand-editor-panel-ready",
      },
      "*"
    );
  }

  set branding(branding: string) {
    this._branding = branding;
    window.parent.postMessage(
      {
        type: "update-branding",
        branding,
      },
      "*"
    );
  }

  get branding(): string {
    return this._branding;
  }
}
